import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import UiIconSmallRight from "@dcl/icons/esm/ui/small-right";

var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  var _super = _createSuper(Tab);

  function Tab(props) {
    var _this;

    _classCallCheck(this, Tab);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tab, [{
    key: "handleClick",
    value: function handleClick(e) {
      this.props.onClick(e, this.props.relatedId);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      this.props.onKeyDown(e);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      // When a tab is selected, make it gain the focus. This ensures that a
      // keyboard user doesn't get lost on the page. In particular, it covers the
      // case of focusing the tab when switching tabs with arrow keys.
      if (this.buttonRef && !oldProps.selected && this.props.selected) {
        this.buttonRef.focus({
          preventScroll: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          layoutVariant = _this$props.layoutVariant,
          relatedId = _this$props.relatedId,
          selected = _this$props.selected,
          title = _this$props.title,
          dataAttribute = _this$props.dataAttribute,
          segment = _this$props.segment,
          subSegment = _this$props.subSegment,
          disabled = _this$props.disabled;
      var getClassName = getClassNameFactory("TabsTab");
      var buttonProps = {
        className: getClassName({
          descendantName: "link"
        }),
        href: "#".concat(relatedId),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        id: "tab-".concat(relatedId),
        role: "tab",
        "data-label": dataAttribute,
        "aria-controls": "".concat(relatedId, "-tab"),
        "data-tab-segment": segment,
        "data-tab-subsegment": subSegment,
        "aria-disabled": disabled
      };

      if (selected) {
        buttonProps["aria-selected"] = true;
      } else {
        buttonProps["aria-selected"] = false; // https://webaim.org/techniques/keyboard/tabindex

        buttonProps.tabIndex = "-1";
      }

      return /*#__PURE__*/React.createElement("li", {
        role: "presentation",
        className: getClassName({
          modifiers: classNames(layoutVariant),
          states: classNames({
            selected: selected,
            disabled: disabled
          })
        })
      }, /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, {
        ref: function ref(_ref) {
          return _this2.buttonRef = _ref;
        },
        target: "_self"
      }), title, layoutVariant === "verticalAtDesktop" && /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "icon"
        })
      }, /*#__PURE__*/React.createElement(UiIconSmallRight, {
        width: 24
      }))));
    }
  }]);

  return Tab;
}(Component);

_defineProperty(Tab, "propTypes", {
  /**
   * Optional modifier to switch layout variants
   */
  layoutVariant: PropTypes.oneOf(["verticalAtDesktop"]),

  /**
   * Event handler for clicking this tab
   */
  onClick: PropTypes.func,

  /**
   * Event handler for pressing a key while focused on this tab
   */
  onKeyDown: PropTypes.func,

  /**
   * The title to display on this tab
   */
  title: PropTypes.string.isRequired,

  /**
   * The HTML ID of the associated tab panel
   */
  relatedId: PropTypes.string.isRequired,

  /**
   * Whether or not this tab is the currently selected tab
   */
  selected: PropTypes.bool,

  /**
   * The title to display in data-label attribute of button.
   */
  dataAttribute: PropTypes.string,

  /**
   * The segment to display in data-tab-segment attribute of button for analytics.
   */
  segment: PropTypes.string,

  /**
   * The subsegment to display in data-tab-subsegment attribute of button for analytics.
   */
  subSegment: PropTypes.string,

  /**
   * Disable tab element
   */
  disabled: PropTypes.bool
});

_defineProperty(Tab, "defaultProps", {
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
});

_defineProperty(Tab, "displayName", "Tabs.Tab");

export default Tab;